import baseURL from "../common/axios";
import { API_MSHospitalBaseUrl } from "../common/common";

class Customerservices {
    // insert api call from supplier form
    insert(data_insert) {
        debugger;
        return baseURL.httpMSInventoryUrl.post("CustomerMAS/Create", data_insert);
    }

    // get edit data from table to form
    EditData(EditID) {
        return baseURL.httpMSInventoryUrl.get("CustomerMAS/Get?id=" + EditID + "");
    }

    // update data from form
    update(data_insert) {
        return baseURL.httpMSInventoryUrl.post("CustomerMAS/Update", data_insert);
    }

    // delete api for deleting data from table
    deletedata(doc) {
        return baseURL.httpMSInventoryUrl.delete("CustomerMAS/Delete?id=" + doc);
    }

    // Active api for activating data from table

    active(Id, Status) {
        return baseURL.httpMSInventoryUrl.put(
            "CustomerMAS/Active?id=" + Id + "&Status=" + Status + ""
        );
    }

    // dropdown api for supplier category
    getdata() {
        return baseURL.httpMSInventoryUrl.get("SupplierCategoryMAS/List");
    }

    // get data for supplier master table
    gettable() {
        return baseURL.httpMSInventoryUrl.get("CustomerMAS/List");
    }

    // dropdown api for payment terms
    getpaymentstermsdd() {
        return baseURL.httpMSInventoryUrl.get("PaymentTermsMAS/List");
    }

    GetSuppliersByStoreId(StoreId, BranchId) {
        debugger;
        return baseURL.httpMSInventoryUrl.get(
            "CustomerMAS/GetSuppliersByStoreId?StoreId=" + StoreId + "&BranchId=" + BranchId + ""
        );
    }

    //FileInsert
    Fileinsert(objinsert) {
        debugger;
        return baseURL.httpMSInventoryUrl.post(
            "CustomerImagesMAS/Create",
            objinsert
        );
    }

    //Get Files by Manufacture Id
    GetFilesBySupplierId(CustomerId) {
        debugger;
        return baseURL.httpMSInventoryUrl.get(
            "CustomerImagesMAS/ListCustomerImagesMASBySupplierMASId?CustomerId=" +
            CustomerId +
            ""
        );
    }
}
export default new Customerservices();
